/* eslint-disable no-param-reassign */
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import _ from 'lodash';
import SimpleReactValidator from 'simple-react-validator';

import { orderProduct } from 'api/order';
import { addStencils } from './slice/addStencils';
import { changeParametersForStencil } from './slice/changeParametersForStencil';
import { deleteStencilsFromCart } from './slice/deleteStencilsFromCart';
import { preserveStencilsParameters } from './slice/preserveStencilsParameters';
import { updateStencilsForOrder } from './slice/updateStencilsForOrder';

import { changeGlobalParameter } from '../actions';
import initialState from './data/DefaultState';
import { changeTab } from '../tabs/tabSlice';
import { TAB_STENCILS } from '../tabs/data/tabType';
import { buildData } from './utils/builders';

import { selectStencilsForValidation } from './selector/selectors';

import { showErrors } from 'product_tabs/alerts/alertSlice';

export const validator = new SimpleReactValidator({});

const stencilService = createSlice({
  name: 'stencilService',
  initialState: {
    ...initialState,
    validatorFlag: false,
  },
  reducers: {
    changeParameter(state, action) {
      const { name, value, ref } = action.payload
      changeParametersForStencil(state, name, value, ref);
      updateStencilsForOrder(state);
    },
    changeStencilsParameter(state, action) {
      const { name, value } = action.payload
      state.stencilsParameters[name] = value;
      updateStencilsForOrder(state);
    },
    changeStencilsType(state, action) {
      state.stencilsType = action.payload;
      validator.purgeFields();
      deleteStencilsFromCart(state);
      addStencils(state);
    },
    changeStencilsSide(state, action) {
      const prevStencilSide = state.stencilsSide;
      const prevStencils = _.cloneDeep(state.stencils);
      deleteStencilsFromCart(state);

      state.stencilsSide = action.payload
      addStencils(state);
      preserveStencilsParameters(state, prevStencilSide, prevStencils);
      updateStencilsForOrder(state);
    },
    deleteStencil(state) {
      deleteStencilsFromCart(state, true);
    },
    updateValidatorFlag(state) {
      // validator.showMessages();
      // validatorProject.showMessages();
      state.validatorFlag = !state.validatorFlag;
    },
  },
  extraReducers(builder) {
    builder.addCase(changeGlobalParameter, (state, action) => {
      const { name, value } = action.payload
      if (!['part_number', 'revision'].includes(name)) return;

      state.stencilsParameters[name] = value;
    });
  },
});

export const {
  changeParameter,
  changeStencilsType,
  changeStencilsSide,
  changeStencilsParameter,
  deleteStencil,
  updateValidatorFlag,
} = stencilService.actions;

export const validate = (prevValidation) => (dispatch, getState) => {
  const {
    stencils,
    stencilsParameters,
    stencilsToDestroy,
  } = selectStencilsForValidation(getState());

  const { part_number, revision, ...restStencilsParameters } = stencilsParameters;

  if(!stencils || !stencils.length || 
    _.isEmpty(restStencilsParameters) && stencils.filter((s) => {
      const { stencil_side, ...check_parameters } = s.parameters;
      return !_.isEmpty(check_parameters);
    }).length === 0) 
    return true;

  const inputFile = $('#gerber-file')
  const file = inputFile ? inputFile.prop('files')[0] : null
  if(stencilsToDestroy && stencilsToDestroy.length && !file) {
    dispatch(showErrors('You have replaced the stencil(s) in your cart, please upload a new zip file for the new stencils.'))
    return false;
  };
  
  if (!validator.allValid()) {
    validator.showMessages();
    dispatch(updateValidatorFlag());
    if (prevValidation) {
      dispatch(changeTab(TAB_STENCILS));
      setTimeout(() => {
        document.querySelector('.stencils .srv-validation-message').scrollIntoView(false);
      }, 500);
    }
    return false;
  }
  return true;
}

export const destroy = (list) => (dispatch, getState) => {
  const { stencilsToDestroy } = getState().smtStencil;

  if (stencilsToDestroy && stencilsToDestroy.length) {
    return list.concat(stencilsToDestroy)
  }

  return list;
}

export const addToCart = (args) => async (dispatch, getState) => {
  const { projectNumber, projectReference, partNumber, revision } = args;
  const state = getState().smtStencil;

  const { stencils } = state;

  // eslint-disable-next-line no-restricted-syntax
  for (const stencil of stencils) {
    const parameters = {
      ...stencil.parameters,
      ...state.stencilsParameters,
      part_number: `${partNumber}-${stencil.parameters.stencil_side}`,
      revision,
    };
    const data = buildData({
      variantId: stencil.variant.id,
      parameters,
      projectNumber,
      projectReference,
    });

    try {
      await orderProduct(data);
    } catch (err) {
      console.error(err)
    }
  }
}

export default stencilService.reducer;
